module.exports = __webpack_public_path__ + "static/14-mission2-other-reason-ab5756677e728a47416f3a9a2e43a76e.png";